chooseActionTypeController.$inject = ['$scope', '$uibModalInstance', '$translate', 'includeTransferAction', 'tagsGroups',
  'isEditAction', 'action', 'optins', 'isCampaignScenario', 'scenarioCustomEvents', 'scenarioCustomEventsMap', 'companyId'];
export function chooseActionTypeController($scope, $uibModalInstance, $translate, includeTransferAction, tagsGroups,
  isEditAction, action, optins, isCampaignScenario, scenarioCustomEvents, scenarioCustomEventsMap, companyId) {
  $scope.selectType = selectType;
  $scope.cancel = cancel;
  $scope.submit = submit;
  $scope.delete = deleteAction;

  init();

  function selectType(type) {
    $scope.action.type = type;
    $scope.selectedTypeLabel = $scope.possibleActionTypes.find(actionType => actionType.code === type).label;
  }

  function submit() {
    let action = {
      type: $scope.action.type
    };
    switch ($scope.action.type) {
      case 'tagAction':
        action.data = {
          tagGroupId: $scope.action.selectedTagGroup.id,
          tagId: $scope.action.selectedTag.id
        };
        action.description = $scope.action.selectedTagGroup.langName + ' = ' + $scope.action.selectedTag.langName;
        break;
      case 'transferAction':
        break;
      case 'assignStaticVariableAction':
        action.name = $scope.action.name;
        action.value = $scope.action.value;
        break;
      case 'assignVariablesFromEndpointAction':
        action.url = $scope.action.url;
        break;
      case 'optinAction':
      case 'optoutAction':
        action.optin = {
          id: $scope.action.selectedOptin?.id
        };
        break;
      case 'tagFromVariableAction':
        action.tagGroupId = $scope.action.selectedTagGroup.id;
        action.variableName = $scope.action.variableName;
        action.description = $scope.action.selectedTagGroup.langName + ' <- ' + $scope.action.variableName;
        break;
      case 'customEventAction':
        action.scenarioCustomEvent = $scope.action.scenarioCustomEvent;
        break;
      case 'archiveAction':
        break;
      case 'passThreadControlAction':
        break;
      case 'exportCapturedMessageContentAction':
        break;
      case 'skipCare':
        break;
      default:
        console.warn('Unexpected action type: ' + $scope.action.type);
        break;
    }
    $uibModalInstance.close({ type: 'edit', action });
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function deleteAction() {
    $uibModalInstance.close({ type: 'delete' });
  }

  function init() {
    $scope.includeTransferAction = includeTransferAction;

    $scope.tagsGroups = tagsGroups;
    $scope.optins = optins;
    $scope.scenarioCustomEvents = scenarioCustomEvents;
    $scope.scenarioCustomEventsMap = scenarioCustomEventsMap;
    $scope.action = action;
    $scope.companyId = companyId;

    $scope.isEditAction = isEditAction;

    $scope.possibleActionTypes = [
      {
        code: 'tagAction',
        label: $translate.instant('parameters/quick_replies/details/new_action_popin/tag_action')
      },
      {
        code: 'transferAction',
        label: $translate.instant('parameters/quick_replies/details/transfer_action/transfer')
      },
      {
        code: 'assignStaticVariableAction',
        label: $translate.instant('parameters/quick_replies/details/new_action_popin/assign_variable')
      },
      {
        code: 'assignVariablesFromEndpointAction',
        label: $translate.instant('parameters/quick_replies/details/new_action_popin/variable_from_endpoint')
      },
      {
        code: 'tagFromVariableAction',
        label: $translate.instant('parameters/quick_replies/details/new_action_popin/tag-from-variable/drop-down-option')
      },
      {
        code: 'archiveAction',
        label: $translate.instant('parameters/quick_replies/details/new_action_popin/archive_action')
      },
      {
        code: 'customEventAction',
        label: $translate.instant('parameters/quick_replies/details/new_action_popin/custom-event/drop-down-option')
      },
      {
        code: 'exportCapturedMessageContentAction',
        label: $translate.instant('parameters/quick_replies/details/new_action_popin/capture_message_content')
      },
      {
        code: 'skipCare',
        label: $translate.instant('parameters/quick_replies/details/new_action_popin/skip_message_and_task_creation')
      },
    ];
    if (isCampaignScenario) {
      $scope.possibleActionTypes.push({
        code: 'optinAction',
        label: $translate.instant('parameters/quick_replies/details/new_action_popin/optin')
      }, {
        code: 'optoutAction',
        label: $translate.instant('parameters/quick_replies/details/new_action_popin/optout')
      }, {
        code: 'passThreadControlAction',
        label: $translate.instant('parameters/quick_replies/details/new_action_popin/pass_thread_control')
      });
    }

    selectType(action.type);
  }

}
